import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function Hero() {
  return <section id="home" className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden" data-id="element-120">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-121">
        <img src="https://cdn.magicpatterns.com/uploads/uFSRTkQpqGVS2Wkoei1sfu/20240508_164249.jpg" alt="Professional lawn mower on a beautifully manicured green lawn" className="w-full h-full object-cover" data-id="element-122" />
        <div className="absolute inset-0 bg-gray-900/70 mix-blend-multiply" data-id="element-123"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-gray-900/40 to-transparent" data-id="element-124"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-125">
        <div className="max-w-3xl" data-id="element-126">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight mb-6" data-id="element-127">
            Beautiful Lawns, <br className="hidden sm:block" data-id="element-128" />
            <span className="text-emerald-400" data-id="element-129">Exceptional Service</span>
          </h1>

          <p className="text-lg sm:text-xl text-gray-200 mb-8 max-w-2xl leading-relaxed" data-id="element-130">
            Professional lawn care services tailored to make your property the
            envy of the neighborhood. Family-owned and dedicated to perfection.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-131">
            <a href="#contact" className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-white bg-emerald-600 rounded-xl hover:bg-emerald-500 transition-all shadow-lg hover:shadow-emerald-600/25 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 focus:ring-offset-gray-900 group" data-id="element-132">
              Get Your Free Quote
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-133" />
            </a>
            <a href="#services" className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-white bg-white/10 backdrop-blur-md border border-white/20 rounded-xl hover:bg-white/20 transition-all focus:outline-none focus:ring-2 focus:ring-white/50 focus:ring-offset-2 focus:ring-offset-gray-900" data-id="element-134">
              Explore Services
            </a>
          </div>
        </div>
      </div>
    </section>;
}